import React, { useState } from "react";
import "./DepositAmount.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/free-solid-svg-icons";

function DepositAmount() {
  const amounts = ["100", "200", "300", "400", "500", "1K", "2K", "3K", "5K"];

  const [selectedAmount, setSelectedAmount] = useState("");
  const [inputValue, setInputValue] = useState("");

  const handleAmountClick = (amt) => {
    let value = amt;

    // convert K values to number
    if (amt.includes("K")) {
      value = parseInt(amt) * 1000;
    }

    setSelectedAmount(amt);
    setInputValue(value);
  };

  const clearInput = () => {
    setInputValue("");
    setSelectedAmount("");
  };

  return (
    <div className="deposit_amount deposit_card_box">
      <div className="card_box">
        <div className="section_header">
          <span className="icon_box">
            <FontAwesomeIcon icon={faBook} />
          </span>
          <h4>Deposit Amount</h4>
        </div>

        <div className="amount_grid">
          {amounts.map((amt, index) => (
            <button
              key={index}
              className={`amount_btn ${selectedAmount === amt ? "active" : ""}`}
              onClick={() => handleAmountClick(amt)}
            >
              ₹ {amt}
            </button>
          ))}
        </div>

        <div className="amount_input_box">
          <span className="currency">₹</span>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="₹100.00 - ₹50,000.00"
          />
          <span className="clear_btn" onClick={clearInput}>✕</span>
        </div>
      </div>
    </div>
  );
}

export default DepositAmount;